<template>
    <div class="password-change-container">
        <h3 class="title">修改密码</h3>
        <el-form :model="passwordForm" :rules="rules" ref="passwordForm" label-width="100px" class="form">
            <el-form-item label="原始密码" prop="oldPassword">
                <el-input v-model="passwordForm.oldPassword" :type="showOldPassword ? 'text' : 'password'" placeholder="请输入">
                    <template slot="append">
                        <i :class="['el-icon-view', showOldPassword ? 'eye-open' : 'eye-close']" @click="toggleVisibility('old')"></i>
                    </template>
                </el-input>
            </el-form-item>
            <el-form-item label="新密码" prop="newPassword">
                <el-input v-model="passwordForm.newPassword" :type="showNewPassword ? 'text' : 'password'" placeholder="请输入">
                    <template slot="append">
                        <i :class="['el-icon-view', showNewPassword ? 'eye-open' : 'eye-close']" @click="toggleVisibility('new')"></i>
                    </template>
                </el-input>
            </el-form-item>
            <el-form-item label="确认密码" prop="confirmPassword">
                <el-input v-model="passwordForm.confirmPassword" :type="showConfirmPassword ? 'text' : 'password'" placeholder="请输入">
                    <template slot="append">
                        <i :class="['el-icon-view', showConfirmPassword ? 'eye-open' : 'eye-close']" @click="toggleVisibility('confirm')"></i>
                    </template>
                </el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="submitForm('passwordForm')">保存</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>


<script>
    import {axios} from '../../config/axios'
  export default {
      data() {
          const validatePass = (rule, value, callback) => {
              if (value === '') {
                  callback(new Error('请输入密码'));
              } else {
                  if (this.passwordForm.confirmPassword !== '') {
                      this.$refs.passwordForm.validateField('confirmPassword');
                  }
                  callback();
              }
          };
          const validatePass2 = (rule, value, callback) => {
              if (value === '') {
                  callback(new Error('请再次输入密码'));
              } else if (value !== this.passwordForm.newPassword) {
                  callback(new Error('两次输入密码不一致!'));
              } else {
                  callback();
              }
          };
      return {
          confirmPassword:'',
          passwordForm: {
              account:JSON.parse(localStorage.getItem("logistics-userInfo")).account,
              oldPassword: '',
              newPassword: '',
              confirmPassword: ''
          },
          showOldPassword: false,
          showNewPassword: false,
          showConfirmPassword: false,

          rules: {
              oldPassword: [
                  { required: true, message: '请输入原始密码', trigger: 'blur' }
              ],
              newPassword: [
                  { required: true, validator: validatePass, trigger: 'blur' }
              ],
              confirmPassword: [
                  { required: true, validator: validatePass2, trigger: 'blur' }
              ]
          }
      }
    },
      methods: {
          toggleVisibility(type) {
              if (type === 'old') {
                  this.showOldPassword = !this.showOldPassword;
              } else if (type === 'new') {
                  this.showNewPassword = !this.showNewPassword;
              } else if (type === 'confirm') {
                  this.showConfirmPassword = !this.showConfirmPassword;
              }
          },
          submitForm(formName) {
              this.$refs[formName].validate((valid) => {
                  if (valid) {
                      // 在这里添加提交表单的逻辑
                      axios.put('user', this.passwordForm).then(result => {
                          if (result.code !== 200){
                              console.log(result);
                              this.$message({
                                  type: 'error',
                                  message: "原始密码输入有误"
                              });
                              return;
                          }
                          this.$message({
                              type: 'success',
                              message: ' 密码修改成功!'
                          });
                          this.clearObj(this.passwordForm);
                          this.passwordForm.confirmPassword = '';
                      }).catch(err => {
                          console.log(err);
                          this.loading=false;
                      });
                  } else {
                      console.log('error submit!!');
                      return false;
                  }
              });
          }
      }
  }
</script>
<style scoped>
    .eye-open {
        cursor: pointer;
        color: #909399; /* 灰色图标 */
    }

    .eye-close {
        cursor: pointer;
        color: #606266; /* 深灰色图标，表示不可见 */
    }
    .password-change-container {
        padding: 20px;
        background-color: #f7f8fa; /* 轻微的背景色提升视觉效果 */
        border-radius: 10px; /* 轻微的圆角 */
        box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1); /* 细微的阴影提升层次感 */
    }

    .title {
        font-weight: 500;
        color: #2e363c;
        margin-bottom: 20px;
    }

    .form {
        width: 80%; /* 优化表单宽度 */
        margin: auto; /* 居中显示 */
    }

    .el-form-item {
        margin-bottom: 20px; /* 增加表单项的间距 */
    }

    .el-button {
        width: 100%; /* 按钮宽度调整为100% */
    }
</style>
